import { Exception } from '../Exception';

export class InternalServerException extends Exception {
  constructor(originalException: unknown) {
    super(undefined, originalException);
  }
}
